/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/

import React from 'react';
import './MeshloadButton.scss';
import Images from 'constants/Images';
import Texts from 'constants/Texts';
import SystemConfiguration from "settings/SystemConfiguration"
import Mesh from "rendering/Mesh"
import $ from "jquery"
import * as THREE from "three";

class MeshloadButton extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true, disabled: false};
    }

    // changeSize = (event) => {
    //   var ele = document.getElementById(this.props.id)
    //   var pos = (document.documentElement.clientWidth / 2 / 3 / 5 * this.props.pos).toString() + "px"
    //   ele.style.setProperty("left", pos);
    // };

    componentDidMount() {
      // var ele = document.getElementById(this.props.id)
      // var pos = (document.documentElement.clientWidth / 2 / 3 / 5 * this.props.pos).toString() + "px"
      // ele.style.setProperty("left", pos);

      // window.addEventListener('resize', (event) => {
      //   this.changeSize()
      // });
    }


    handleClick(version) {
      SystemConfiguration.active_type = version

      if(this.state.disabled)
        return

      console.log(version)

      try {
        if (version == "shading" || version == "texture")
          version = version + "_" + SystemConfiguration.active_time
        var new_tex = new THREE.TextureLoader().load(process.env.PUBLIC_URL + '/data/meshes/' + SystemConfiguration.mesh_name + '/' + SystemConfiguration.mesh_name +'_'+version+'.jpg')
        SystemConfiguration.material.map = new_tex
        // encoding is set to 3000 which makes the visible brighter
        // set it to 3001 for correct brightness
        SystemConfiguration.material.map.encoding = 3001
        SystemConfiguration.material.map_temp = new_tex
        SystemConfiguration.material.map_temp.encoding = 3001
        SystemConfiguration.material.needsUpdate = true
        console.log(SystemConfiguration.mesh.material)
      } catch (error) {
        console.log(error)
      }

      // try {
      //   if(version != "") {
      //     var f_name = "data/meshes/" + SystemConfiguration.mesh_name + "/" + SystemConfiguration.mesh_name + "_" + version

      //     if (version == "shading" || version == "texture")
      //       var f_name = f_name + "_" + SystemConfiguration.active_time
      //     console.log(f_name)
      //   }else
      //     var f_name = "data/meshes/" + SystemConfiguration.mesh_name + "/" + SystemConfiguration.mesh_name

      //     SystemConfiguration.mesh_out = <Mesh file_name={f_name}></Mesh>  
      //     $("#rightpanel_header").html(SystemConfiguration.mesh_name).css("color", "black")
      // } catch (error) {
      //   console.log(error)
      // }
    }

    render() {
        return (
            <div className={this.props.className} title={this.props.load} onClick={() => this.handleClick(this.props.load)}>{this.props.label}</div>
        );
    }
  }

export default MeshloadButton;